import React from "react";
import PropTypes from "prop-types";
import { constants, log } from "@qgiv/core-js";

import {
    ClassificationDetailsControl,
    ConnectedAdditionalInfoControl,
    ConnectedAddToCalendarControl,
    ConnectedDeliveryNoteControl,
    ConnectedEmergencyContactControl,
    ConnectedEmployerMatchingControl,
    ConnectedParticipantDetailsControl,
    ConnectedPaymentContentControl,
    ConnectedPrivacyOptionsControl,
    ConnectedReceiptFundraisingAccountControl,
    ConnectedRegistrationContentControl,
    ConnectedShippingInfoControl,
    ConnectedStoreHeadingControl,
    ConnectedWaiverControl,
    ConnectedWidgetCustomContentControl,
    ConnectedWidgetHeadingControl,
    ConnectedWidgetSpacing,
    ConnectedWidgetText,
    DisplaySubmit,
    GiftAssistControl,
    OptionalDonationControl,
    ReceiptFooterControl,
    ReceiptHeaderControl,
    ReceiptRegistrationDetailsControl,
    StoreContentControl,
} from "../Controls";

const P2PRegistrationControl = ({ control: { type }, ...props }) => {
    const { CMS_Control } = constants.ENUMS;

    switch (Number(type)) {
        case CMS_Control.P2P_REGISTRATION_CLASSIFICATIONS:
            return <ClassificationDetailsControl {...props} />;
        case CMS_Control.P2P_REGISTRATION_CONTENT:
            return <ConnectedRegistrationContentControl {...props} />;
        case CMS_Control.P2P_PERSONAL_INFO:
            return <ConnectedParticipantDetailsControl {...props} />;
        case CMS_Control.P2P_EMERGENCY_CONTACTS:
            return <ConnectedEmergencyContactControl {...props} />;
        case CMS_Control.P2P_CUSTOM_FIELDS:
            return <ConnectedAdditionalInfoControl {...props} />;
        case CMS_Control.P2P_STORE_HEADING:
            return <ConnectedStoreHeadingControl {...props} />;
        case CMS_Control.P2P_STORE_PRODUCTS:
            return <StoreContentControl {...props} />;
        case CMS_Control.P2P_GIFT_ASSIST:
            return <GiftAssistControl {...props} />;
        case CMS_Control.P2P_WAIVER:
            return <ConnectedWaiverControl {...props} />;
        case CMS_Control.P2P_PAYMENT_CONTENT:
            return <ConnectedPaymentContentControl {...props} />;
        case CMS_Control.P2P_FOOTER_REGISTRATION_BUTTONS:
            return <DisplaySubmit {...props} />;
        case CMS_Control.OPTIONAL_GIFT:
            return <OptionalDonationControl {...props} />;
        case CMS_Control.P2P_MATCHING_GIFT:
            return <ConnectedEmployerMatchingControl {...props} />;
        case CMS_Control.P2P_REGISTRATION_RECEIPT_HEADER:
            return <ReceiptHeaderControl {...props} />;
        case CMS_Control.P2P_REGISTRATION_RECEIPT_FUNDRAISING_ACCOUNT:
            return <ConnectedReceiptFundraisingAccountControl {...props} />;
        case CMS_Control.P2P_REGISTRATION_RECEIPT_REGISTRATION_DETAILS:
            return <ReceiptRegistrationDetailsControl {...props} />;
        case CMS_Control.P2P_REGISTRATION_RECEIPT_FOOTER:
            return <ReceiptFooterControl {...props} />;
        case CMS_Control.WIDGET_HEADING:
            return <ConnectedWidgetHeadingControl {...props} />;
        case CMS_Control.WIDGET_CUSTOM_CONTENT:
            return <ConnectedWidgetCustomContentControl {...props} />;
        case CMS_Control.WIDGET_TEXT:
            return <ConnectedWidgetText {...props} />;
        case CMS_Control.WIDGET_SPACING:
            return <ConnectedWidgetSpacing {...props} />;
        case CMS_Control.P2P_SHIPPING_INFO:
            return <ConnectedShippingInfoControl {...props} />;
        case CMS_Control.P2P_DELIVERY_NOTE:
            return <ConnectedDeliveryNoteControl {...props} />;
        case CMS_Control.P2P_PRIVACY_OPTIONS:
            return <ConnectedPrivacyOptionsControl {...props} />;
        case CMS_Control.EVENT_ADD_TO_CALENDAR:
            return <ConnectedAddToCalendarControl {...props} />;
        default:
            log("error", [`Missing Control Type: ${type}`, { props }]);
            return <h1>No Control Exists</h1>;
    }
};

P2PRegistrationControl.propTypes = {
    control: PropTypes.shape({
        type: PropTypes.oneOfType([PropTypes.number, PropTypes.string])
            .isRequired,
    }).isRequired,
};

export default P2PRegistrationControl;
